// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3021":"a689b377365181e4","3733":"18086648fea84be7","4449":"ddc6ccd5b0dc16b3","6352":"85cb4a5378dce580","6624":"657e256944379e9b","8095":"e898bf2f89afa314"}[chunkId] + ".css";
};